import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  Component,
  Directive,
  HostBinding,
  Input,
  OnInit,
  OnChanges,
  ElementRef,
  AfterViewInit,
  inject,
  input,
  output
} from '@angular/core';

@Component({
    selector: '[exlFramedForm]',
    template: '<ng-content></ng-content>',
    styleUrls: ['./framed-form.directive.scss'],
    host: { '[class.exl-framed-form]': 'true' },
    standalone: true,
})
export class FramedFormComponent implements OnInit, OnChanges {
    directiveClass = 'exl-framed-form';
    readonly exlFramedForm = input(null);
    readonly exlFramedFormTheme = input<
        'light' | 'dark' | 'primary' | 'accent'
    >('dark');
    @HostBinding('class.is-active') activeClass = false;
    @HostBinding('class.is-visible') visibleClass = false;
    @HostBinding('class.is-animating') animateClass = false;
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @HostBinding('class') @Input('class') classList = '';

    ngOnInit() {
        this.setHostClasses();
    }

    ngOnChanges(changes) {
        const change = changes['exlFramedForm'];
        if (change && !change.firstChange) {
            /* remove classes */
            if (change.currentValue === null || change.currentValue === false) {
                this.visibleClass = false;
                this.animateClass = true;
                setTimeout(() => {
                    this.activeClass = false;
                    this.animateClass = false;
                }, 200);
            } else {
                this.animateClass = true;
                this.activeClass = true;
                setTimeout(() => {
                    this.visibleClass = true;
                }, 0);
                setTimeout(() => {
                    this.animateClass = false;
                }, 500);
            }
        }
    }

    setHostClasses() {
        const themeClass = 'exl-theme-' + this.exlFramedFormTheme();
        const currentClasses = this.classList;
        this.classList = `${this.directiveClass} ${themeClass} ${currentClasses}`;
    }
}

// Form content directive - without it the directive will not style everything as desired
@Directive({
    selector: '[exlFramedFormContent]',
    host: {
        class: 'exl-framed-form-content',
        '(keydown.escape)': 'closeFrame($event)',
        // 'role': 'form',
    },
    standalone: true,
})
export class FramedFormContentDirective implements AfterViewInit {
    private elementRef = inject(ElementRef);

    readonly closeFrom = output<any>();
    readonly focusTimeoutDuration = input(500);

    ngAfterViewInit() {
        const interactiveElements =
            this.elementRef.nativeElement.querySelectorAll(
                'mat-select, input, textarea',
            );
        if (
            interactiveElements &&
            interactiveElements.length > 0 &&
            !!interactiveElements.item(0)['focus']
        ) {
            const first = interactiveElements.item(0) as HTMLInputElement;
            setTimeout(() => {
                first.focus();
            }, this.focusTimeoutDuration());
        }
    }

    closeFrame(event: KeyboardEvent) {
        // Prevent close on opened select dropdown close event
        const el = event.target as HTMLElement;
        if (!coerceBooleanProperty(el.ariaExpanded)) {
            this.closeFrom.emit(event);
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
